/** API que expõe o motor de cálculo (`MotorCalculo/simular`) consumido pelo modal genérico de simulação. */
export enum ApiMotorCalculoEnum {
  MotorFiscal = 1,
  Suprimentos = 2,
}
